import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { FilterTabType } from '../../../imageFilters.model';
import { FilterHeader } from '../FilterHeader';
import { ImageFiltersFormProps } from '../ImageFiltersForm';

export const StatusHeader = observer((props: ImageFiltersFormProps): ReactElement => {
  const handleClear = (): void => {
    props.onSetStatuses([]);
  };

  const isSelected = props.activeFilterType === FilterTabType.Status;
  const count = props.imageFilters.annotationStatuses.length;

  return (
    <FilterHeader
      filterType={FilterTabType.Status}
      isSelected={isSelected}
      labelKey='status'
      count={count}
      showClear={count > 0}
      onClear={handleClear}
      onSelect={props.onFilterTabSelect}
    />
  );
});
